import React, { useEffect,useMemo } from 'react';
import "./ConferenceDecision.css"
import Header from "../../../components/Header";
import Remarks from '../../../components/Remarks/Remarks';
import useAuth from '../../../../customHooks/useAuth';
import { useLocation,useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../../common/baseUrl';
import axiosInstance from '../../../../axiosInstance/axiosInstance';
import { HOTEL_TIMEZONE } from "../../../../common/hotelTime";


export default function ConferenceDecision() {

    const location = useLocation();
    const navigate = useNavigate();

    const Data = location.state?.Data || {};
    const hotelId = location.state?.hotelId || "";
    const bookingId = location.state?.bookingId || "";
    const requestId = location.state?.requestId || "";
    const status = location.state?.status || "";
    const bookedRoomId = location.state?.bookedRoomId || "";
    const userId = localStorage.getItem('user_id');


    // useAuth Refresh
    useAuth();

    const formattedStatus = useMemo(() => {
        return  status.replace('_', ' ');
    }, [status]);
    

    // CheckId's
    useEffect(()=>{
        const checkId = ()=>{
            if(hotelId==="" || bookingId==="" || requestId===""){
                navigate("/bookings");
            }
        }
        checkId();

    },[hotelId,bookingId,requestId,navigate]);


    
    // Function to format the date (e.g., "07 Oct")
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        return `${day} ${month}`;
    };

    // Function to format the time (e.g., "22:11")
    const formatTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString([], {
            timeZone: HOTEL_TIMEZONE, hour: '2-digit', minute: '2-digit' });
    };

    // Handle Accept Fee
    const acceptFee = async() => {
        try{

            const response = await axiosInstance.patch(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${bookedRoomId}/guest-requests/post-checkin/conference-room-request/user-verdict?guest_request_id=${requestId}`,{
                accepted_by_guest: true
            });

            // console.log("Accept Fee : ",response.data);
            toast.success("Conference Room Fee Accepted Successfully");
            navigate("/bookings",{state : {activeRequests : "requests"}})

        }catch(error){
            toast.error(error?.response?.data?.message || "Some Error Occured");
            console.log(error);
        }
    }

    // Handle Reject Fee
    const rejectFee = async()=>{
        try{
            const response = await axiosInstance.patch(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${bookedRoomId}/guest-requests/post-checkin/conference-room-request/user-verdict?guest_request_id=${requestId}`,{
                accepted_by_guest: false
            });

            // console.log("Reject Fee : ",response.data);
            toast.success("Conference Room Fee Rejected Successfully");
            navigate("/bookings",{state : {activeRequests : "requests"}})

        }catch(error){
            toast.error(error?.response?.data?.message || "Some Error Occured");
            console.log(error);
        }

    }

    
    // Close Request
    const closeRequest = async()=>{
        try{
            const response = await axiosInstance.put(`/api/v1/users/${userId}/guest-requests/${requestId}/close`);
            // console.log("Request Cancelled : ",response.data);
            toast.success("Conference Room Request Cancelled Successfully");
            navigate("/bookings",{state : {activeRequests : "requests"}});
        }catch(error){
            toast.error(error.response.data.message);
            console.log(error);
        }
    }

    
  return (
    <div className='conferenceDecision'>
        <Header title="Conference Room Request" />

        <div className='conference-view'>

            {/* Status */}
            <div className='conference-status'>
                <h4>{formattedStatus}</h4>
            </div>

            {/* Date of the serivce */}
            <div className='conference-data'>
                <h4>Date of the serivce</h4>
                <div className='conference-inp'>
                    <h5>{formatDate(Data.preferred_time)}</h5>
                </div>
            </div>

            {/* When do you want the conference room? */}
            <div className='conference-data'>
                <h4>When do you want the conference room?</h4>
                <div className='conference-inp'>
                    <h5>{formatTime(Data.preferred_time)}</h5>
                </div>
            </div>

            {/* People */}
            <div className='conference-data'>
                <h4>Number of People</h4>
                <div className='conference-inp'>
                    <h5>{Data.number_of_people}</h5>
                </div>
            </div>

            {/* How long do you want the conference room for? */}
            <div className='conference-data'>
                <h4>How long do you want the conference room for?</h4>
                 
                <div className='conference-inp'>
                    {(() => {
                        const [hours, minutes] = Data?.duration_hours.split('.') || "Time";
                        
                        return (
                            <h5>
                                {hours} Hours {minutes} Minutes
                            </h5>
                        );
                    })()}
                </div>

            </div>

            {/* Comments */}
            {Data.additional_comments && 
                <div className='conference-data'>
                    <h4>Comments</h4>
                    <div className='conference-comment'>
                        <h5>{Data.additional_comments}</h5>
                    </div>
                </div>
            }

            {/* Price quoted by Hotel */}
            {Data.total_amount!=0 && Data.total_amount!=null && 
                <div className='conference-data'>
                    <h4>Price quoted by Hotel</h4>
                    <div className='conference-inp'>
                        <h5>₹ {Data.total_amount}</h5>
                    </div>
                </div>
            }

            {Data.total_amount===0 && 
                <div className='conference-data'>
                    <h4>Price quoted by Hotel</h4>
                    <div className='conference-inp'>
                        <h5>₹ {Data.total_amount}</h5>
                    </div>
                </div>
            }



            {/* Conference Room */}
            {Data.conference_room_number && 
                <div className='conference-data'>
                    <h4>Conference Room </h4>
                    <div className='conference-inp'>
                        <h5>{Data.conference_room_number}</h5>
                    </div>
                </div>
            }

        </div>
        {Data.remarks && 
            <Remarks para={Data.remarks} />
        }

        {
            (Data.status ==="Completed_Hotel" || Data.status ==="Completed_Guest" || Data.status ==="Declined_Guest" || Data.status ==="Declined_Hotel" || Data.status ===
            "Closed_Guest") ?

            (<div></div>)
            :
            (Data.status==="Pending_Hotel" || Data.status==="Scheduled_Hotel" || Data.status==="InProgress_Hotel") ? (
                <div className="cancel-btn">
                    <button onClick={closeRequest}>Cancel Request</button>
                </div>
            ) :
            (
                <div className='conference-btn'>
                    <div className='accept-btn'>
                        <button onClick={acceptFee}>Accept Price</button>
                    </div>
                    <div className='reject-btn'>
                        <button onClick={rejectFee}>Reject Price</button>
                    </div>
                </div>
            )
        }
    </div>
  )
}
